<template src="./RevisionSolicitud.html"></template>

<script>
import {
  Breadcrumb,
  BreadcrumbItem,
  Button,
  DatePicker, Descriptions, DescriptionsItem,
  Divider,
  Form,
  FormItem,
  Option,
  Select,
  Tag
} from "element-ui";
import {requestRevisionMixin} from "@/api/partidoPolitico/revisionApi";
import {NotifyMixin} from "@/mixins/NotifyMixin";
import ScreenSizeMixin from "@/mixins/ScreenSizeMixin";
import {FechaMaximaReclamacionMixin} from "@/mixins/FechaMaximaReclamacionMixin";
import {RouterMixin} from "@/mixins/routerMixin";
import moment from "moment-timezone";
import AfiliacionDetail from "@/components/Shared/AfiliacionDetail/AfiliacionDetail";

export default {
  name: "RevisionSolicitud",
  components: {
    [Descriptions.name]: Descriptions,
    [DescriptionsItem.name]: DescriptionsItem,
    AfiliacionDetail,
    [Form.name]: Form,
    [FormItem.name]: FormItem,
    [Select.name]: Select,
    [Option.name]: Option,
    [DatePicker.name]: DatePicker,
    [Button.name]: Button,
    [Breadcrumb.name]: Breadcrumb,
    [BreadcrumbItem.name]: BreadcrumbItem,
    [Divider.name]: Divider,
    [Tag.name]: Tag,
  },
  mixins: [
    requestRevisionMixin,
    NotifyMixin,
    ScreenSizeMixin,
    FechaMaximaReclamacionMixin,
    RouterMixin,
  ],
  data() {
    return {
      loading: true,
      errored: false,
      listaEstadoRevision: [],
      listaRechazo: [],
      model: {
        id: '',
        estadorevision: '',
        instancia: "",
        descripcionRechazo: "",
        motivorechazo: '',
      },
      afiliacion: {
        rut: "",
        nombreCompleto: "",
        domicilio: "",
        fechaNacimiento: '',
        email: "",
        telefonoMovil: "",
        telefonoFijo: "",
      },
      rules: {
        motivorechazo: [
          {
            required: true,
            message: 'Seleccione un Motivo de rechazo',
            trigger: ['blur', 'change']
          }
        ],
        estadorevision: [
          {
            required: true,
            message: 'Seleccione un Estado de revisión',
            trigger: ['blur', 'change']
          }
        ],
        instancia: [
          {
            required: true,
            message: 'Escriba una instancia de reclamo',
            trigger: ['blur', 'change']
          },
          {
            min: 20,
            message: 'Escriba una instancia de reclamo con mínimo 20 caracteres',
            trigger: ['blur', 'change']
          },
          {
            max: 600,
            message: 'Escriba una instancia de reclamo con máximo 400 caracteres',
            trigger: ['blur', 'change']
          }
        ],
        descripcionRechazo: [
          {
            required: true,
            message: 'Escriba un motivo de rechazo',
            trigger: ['blur', 'change']
          },
          {
            min: 20,
            message: 'Escriba un motivo de rechazo con mínimo 20 caracteres',
            trigger: ['blur', 'change']
          },
          {
            max: 600,
            message: 'Escriba un motivo de rechazo con máximo 400 caracteres',
            trigger: ['blur', 'change']
          }
        ],
      }
    };
  },
  beforeMount() {
    this.model.id = this.$route.params.id
    this.getData()
  },
  methods: {
    afiliacionRevisionVer() {
      return new Promise((resolve, reject) => {
        this.getAfiliacionRevisionVer(this.model.id)
          .then((response) => {
            this.$log.debug('getAfiliacionRevisionVer', response.data.statusCode)
            if (response.data.statusCode === 200) {
              const data = JSON.parse(response.data.datos);
              this.$log.debug(data)

              this.afiliacion.rut = data.cedula
              this.afiliacion.nombreCompleto = data.nombrecompleto
              this.afiliacion.fechaNacimiento = moment(data.fechanacimiento, "YYYYMMDD").format('DD-MM-YYYY')
              this.afiliacion.email = data.email;
              this.afiliacion.domicilio = data.domicilio
              this.afiliacion.telefonoMovil = data.telefonomovil
              this.afiliacion.telefonoFijo = data.telefonofijo
            } else {
              this.errored = true;
              this.showInfo('No hay datos de su persona')
              reject()
            }
            resolve()
          })
          .catch((err) => {
            this.$log.fatal('getAfiliacionRevisionVer', err, err.response, err.request)
            this.showError("Error al cargar la data de Afiliación")
            reject(err)
          });
      })
    },
    revisionEstado() {
      return new Promise((resolve, reject) => {
        this.getRevisionEstado()
          .then((response) => {
            this.$log.debug('getRevisionEstado', response.data.statusCode)
            this.listaEstadoRevision = JSON.parse(response.data.datos);
            resolve()
          })
          .catch((err) => {
            this.$log.fatal('getRevisionEstado', err, err.response, err.request)
            this.showError("Error al cargar los estados de la Revisión");
            reject(err)
          });
      })
    },
    revisionMotivoRechazo() {
      return new Promise((resolve, reject) => {
        this.getRevisionMotivoRechazo()
          .then((response) => {
            this.$log.debug('getRevisionMotivoRechazo', response.data.statusCode)
            this.listaRechazo = JSON.parse(response.data.datos);
            resolve()
          })
          .catch((err) => {
            this.$log.fatal('getRevisionEstado', err, err.response, err.request)
            this.showError("Error al cargar los motivos de rechazo");
            reject(err)
          });
      })
    },
    getData() {
      const afiliacionRevisionVerFn = this.afiliacionRevisionVer()
      const revisionEstadoFn = this.revisionEstado()
      const revisionMotivoRechazoFn = this.revisionMotivoRechazo()
      const fechaMaximaReclamacionFn = this.fechaMaximaReclamacion()

      this.loading = true
      Promise.all([afiliacionRevisionVerFn,
        revisionEstadoFn,
        revisionMotivoRechazoFn,
        fechaMaximaReclamacionFn])
        .then(() => {
          this.$log.debug("request completados")
          this.errored = false
        })
        .catch((err) => {
          this.errored = true
          this.$log.fatal('error al ejecutar los request', err)
        })
        .finally(() => {
          this.loading = false
        })
    },
    generarData() {
      let data = {}

      data.ident = this.model.id
      data.estado_id = this.model.estadorevision
      data.motivo_rechazo_id = this.model.motivorechazo === '' ? 0 : this.model.motivorechazo
      data.descripcion = this.model.descripcionRechazo
      data.instancia = this.model.instancia
      data.plazo_max_reclamo = moment(this.model.fechaMaxima, 'DD-MM-YYYY').toDate()

      return data
    },
    enviarRevisionSolicitud() {
      this.$log.debug('enviarRevisionSolicitud')
      this.$refs['revisionSolicitudForm'].validate((valid) => {

        if (valid) {
          this.$log.debug("enviando...")
          const loading = this.getLoading()

          const data = this.generarData()
          this.$log.debug('enviarRevisionSolicitud', data)

          return this.crearRevision(data)
            .then((response) => {
              this.$log.debug('crearRevision', response.data.statusCode)
              loading.close()

              if (response.data.statusCode === 201) {
                this.showSuccess("La revisión se ha ingresado correctamente");
                this.navigate({name: 'solicitud'})

                return true
              } else if (response.data.statusCode === 404) {
                this.showInfo('No se encontraron afiliaciones para aprobar')
                return false
              } else {
                this.showError('Ocurrió un error inesperado al enviar la revisión')
                return false
              }
            })
            .catch((err) => {
              this.$log.fatal('crearRevision', err, err.response, err.request)
              loading.close();
              this.showError("No se ha podido ingresar la revisión");

              return false
            });

        } else {
          this.$log.debug('error submit!!')
          return false
        }
      })
    },
  },

};
</script>
